<template>
  <pi-content>
    <div class="station-details v-service-station-detail">
      <section class="station-info-section">
        <div class="company-name-container">
          <div class="content">{{ details.staName }}</div>
        </div>
        <van-notice-bar
          left-icon="volume-o"
          :scrollable="true"
          v-if="staNoticeList.length > 0"
        >
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item
              @click="noticeClick(item)"
              v-for="(item, index) in staNoticeList"
              :key="index"
              >{{ item.content }}</van-swipe-item
            >
          </van-swipe>
        </van-notice-bar>
        <!-- <van-notice-bar scrollable
          left-icon="volume-o"
          text="站点公告"
          @click="noticeClick"
        /> -->
        <div class="tag-list">
          <pi-tag
            type="primary"
            v-for="(item, index) in details.staTags"
            :key="index"
            >{{ item }}</pi-tag
          >
        </div>

        <div
          class="station-img"
          v-if="details.staPics && details.staPics.length > 0"
        >
          <ul
            class="station-img-list"
            ref="stationList"
            :style="{ width: stationImgWidth }"
          >
            <li
              class="station-img-item"
              @click="queryImg(item.imageUrl)"
              v-for="(item, index) in details.staPics"
              :key="index"
            >
              <img :src="$config.fileUrl + item.imageThumbnailUrl" />
            </li>
          </ul>
        </div>
        <div
          class="station-tips"
          v-if="details.remarks && details.remarks != ''"
        >
          温馨提示：{{ details.remarks }}
        </div>
      </section>

      <van-tabs sticky color="#14CC80" v-model="active">
        <van-tab title="费用">
          <pi-station
            :details="details"
            v-if="details.staPkId"
            @feeSuccess="feeSuccess"
            @goAddr="goAddr"
          ></pi-station>
        </van-tab>
        <van-tab title="电桩">
          <pile2 :details="details" :active="active"></pile2>
        </van-tab>
      </van-tabs>
    </div>
    <div class="bottom-info-null"></div>
    <div class="bottom-info">
      <div class="collected" @click="collect(details, !details.ifCollected)">
        <img
          :src="
            details.ifCollected
              ? require('../../assets/img/ic_station_favourite_checked.png')
              : require('../../assets/img/ic_station_favourite.png')
          "
        />
        收藏
      </div>
      <div class="qr-code">
        <button class="qr-code-btn" @click="scanCodeRecharge">扫码充电</button>
      </div>
    </div>
  </pi-content>
</template>

<script>
import { Tab, Tabs, ImagePreview, NoticeBar, Swipe, SwipeItem } from "vant";
// import Station2 from "./station";
import Station from "./components/station/station.vue";
import Pile2 from "./components/pile/pile.vue";
import { getStationDetail, getStaNotice } from "@/common/api/index";
import wxJsSdk from "../../common/location";
import { collectStation, getChargePrepareInfo } from "../../common/api";
import Tag from "@/components/pi-tag/pi-tag";
export default {
  name: "station-details",
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Station.name]: Station,
    [Pile2.name]: Pile2,
    [Tag.name]: Tag,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      active: 0,
      details: {},
      staTags: [],
      userLat: "",
      userLng: "",
      // stationPic: {
      //   background: ''
      // },
      imagePath: "",
      stationImgWidth: "100%",
      feeDetail: {},
      staNoticeList: [],
    };
  },
  mounted() {
    wxJsSdk.reConfig();
    this.getLocation();
    this.getStaNotice();
    this.$common.bodyAddBg();
  },
  destroyed() {
    this.$common.removeBodyBg();
  },
  methods: {
    noticeClick(item) {
      this.$router.push("/notice-content?id=" + item.noticePkId);
    },
    feeSuccess(data) {
      this.feeDetail = data;
    },
    queryImg(url) {
      let urls = [];
      let origin = window.location.origin;
      this.details.staPics.map((item) => {
        urls.push(origin + this.$config.fileUrl + item.imageUrl);
      });
      let current = origin + this.$config.fileUrl + url;

      if (process.env.NODE_ENV == "production") {
        wxJsSdk.previewImage(
          current,
          urls // 需要预览的图片http链接列表
        );
      }
    },
    openImagePreView() {
      if (this.details.staPics && this.details.staPics.length !== 0) {
        let images = this.details.staPics.map((item) => {
          return this.$config.fileUrl + item.imageUrl;
        });
        ImagePreview({
          images: images,
          closeable: true,
          closeOnPopstate: true,
        });
      }
    },
    getLocation() {
      if (process.env.NODE_ENV == "production") {
        wxJsSdk.getLocation({
          type: "gcj02",
          success: (res) => {
            this.userLat = res.latitude;
            this.userLng = res.longitude;
            this.getDetail();
          },
          fail: () => {
            this.userLat = 22.257935;
            this.userLng = 113.537618;
            this.getDetail();
          },
          catch: () => {
            this.userLat = 22.257935;
            this.userLng = 113.537618;
            this.getDetail();
          },
        });
      } else {
        this.userLat = 22.257935;
        this.userLng = 113.537618;
        this.getDetail();
      }
    },
    goAddr() {
      var data = {
        latitude: this.details.staLat,
        longitude: this.details.staLng,
        name: this.details.staName,
        address: this.details.staAddress,
      };
      wxJsSdk.openLocation(data);
    },
    getStaNotice() {
      getStaNotice({ staPkId: this.$route.query.staPkId }).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          this.staNoticeList = data.data;
        }
      });
    },
    getDetail() {
      getStationDetail(
        {
          userLat: this.userLat,
          userLng: this.userLng,
          staPkId: this.$route.query.staPkId,
        },
        true
      )
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            this.details = data.data[0];
            if (this.details.staTags) {
              this.staTags = this.details.staTags.filter((item) => {
                return !this.$common.isEmpty(item);
              });
            }
            this.$route.params.staCharacter = this.details.staCharacter; //保存到route,params参数中，然后pile组件内使用
            this.imagePath =
              this.details.staPics && this.details.staPics.length > 0
                ? this.$config.fileUrl +
                  this.details.staPics[0].imageThumbnailUrl
                : "";
            this.$nextTick(() => {
              let len = this.details.staPics.length;
              console.log(len);
              if (len > 0) {
                let div = this.$refs.stationList;
                let li = div.getElementsByTagName("li");
                let width = li[0].offsetWidth + 10;
                this.stationImgWidth = width * len + "px";
              }
            });
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          // this.$toast("详情:" + error);
          // console.log(error);
        });
    },
    collect(stationData, collect) {
      // console.log(stationData);
      collectStation(
        {
          staPkId: stationData.staPkId,
          status: collect,
        },
        true
      )
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            stationData.ifCollected = collect;
          } else {
            throw new Error();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast(collect ? "收藏失败" : "取消收藏失败");
        });
    },
    scanCodeRecharge() {
      wxJsSdk.scanQRCode({
        success: (res) => {
          let data = this.getScanCodeData(res);
          if (data) {
            this.gotoCharge(data);
          } else {
            this.$toast("二维码不正确，请重新扫描");
          }
        },
        fail: () => {
          this.$toast("扫码失败");
        },
      });
    },
    getScanCodeData(url) {
      let str = "hlht://";
      if (url.indexOf(str) != -1) {
        let dataStr = url.substring(str.length, url.length);
        let arr = dataStr.split(".");
        let gunPkId = arr[0];
        let operatorId = "";
        let customInfo = "";
        if (arr[1]) {
          let arr2 = arr[1].split("/");
          operatorId = arr2[0];
          customInfo = arr2[1] || "";
          return {
            gunPkId: gunPkId,
            operatorId: operatorId,
            customInfo: customInfo,
          };
        } else {
          this.$toast("请扫描正确的二维码");
          return null;
        }
      } else if (
        url.indexOf("http://") != -1 ||
        url.indexOf("https://") != -1
      ) {
        let gunPkId = this.$common.query("gid", url);
        let operatorId = this.$common.query("orgCode", url);
        if (gunPkId && operatorId) {
          return {
            gunPkId: gunPkId,
            operatorId: operatorId,
            customInfo: "",
          };
        } else {
          this.$toast("请扫描正确的二维码");
          return null;
        }
      } else {
        this.$toast("请扫描正确的二维码");
        return null;
      }
    },
    gotoCharge(formData) {
      //先检查桩能不能用
      formData.enterWay = this.enterWay;
      getChargePrepareInfo(formData)
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            if (!data.code || data.code == "SUCCESS") {
              // 桩没问题，正常跳转
              this.$router.push({
                name: "charge/ready",
                query: formData,
              });
            } else if (data.code == "202002") {
              this.$dialog
                .confirm({
                  message: data.msg,
                  confirmButtonText: "充值",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                })
                .then(() => {
                  this.$router.push({
                    name: "recharge",
                  });
                })
                .catch(() => {});
            } else {
              this.$dialog
                .alert({
                  message: data.msg,
                  confirmButtonText: "确认",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                })
                .then(() => {});
            }
          } else {
            this.$dialog
              .alert({
                message: data.msg,
                confirmButtonText: "确定",
                confirmButtonColor: "#14CC80",
                closeOnPopstate: true,
              })
              .then(() => {});
          }
        })
        .catch((error) => {
          console.log(error);
          this.$dialog
            .alert({
              message: "查询桩状态失败",
              confirmButtonText: "确定",
              confirmButtonColor: "#14CC80",
              closeOnPopstate: true,
            })
            .then(() => {});
        });
    },
  },
};
</script>

<style lang="less">
@import "../../components/pi-station-item/public.less";

.station-details {
  .van-notice-bar {
    height: 0.4rem;
    font-size: 0.24rem;
    margin: 0.05rem -0.2rem 0;
    .van-notice-bar__content.van-ellipsis {
      width: 100%;
    }
  }
  .notice-swipe {
    height: 0.4rem;
    line-height: 0.4rem;
    .van-swipe-item {
      width: 100% !important;
    }
  }
  .station-info-section {
    background-color: #fff;
    padding: 0.2rem;
    margin-bottom: 0.1rem;
    .tag-list {
      margin-top: 0.07rem;
    }
  }
  .company-name-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content {
      color: #333333;
      font-size: 0.4rem;
      line-height: 0.56rem;
    }
    img {
      width: 0.3rem;
      height: 0.28rem;
      pointer-events: auto;
    }
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none;
  }

  .station-img {
    margin-top: 0.25rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    .station-img-list {
      font-size: 0;
      // width: 500px;
      .station-img-item {
        width: 2.6rem;
        height: 1.6rem;
        background-color: #f5f5f5;
        border-radius: 0.1rem;
        margin-left: 10px;
        box-sizing: border-box;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
          border-radius: 0.1rem;
          pointer-events: auto;
        }
      }
      .station-img-item:first-child {
        margin-left: 0;
      }
    }
  }
  .station-tips {
    margin-top: 0.12rem;
    font-size: 0.28rem;
    line-height: 0.36rem;
    color: #666;
  }
}
.bottom-info-null {
  height: 1.2rem;
}
.bottom-info {
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  padding: 0.18rem 0.3rem 0.18rem 0.2rem;
  box-shadow: 0px 0px 0.02rem 0.03rem rgba(102, 102, 102, 0.2);

  .collected {
    display: flex;
    align-items: center;
    justify-items: center;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #666;
    img {
      width: 0.38rem;
      height: 0.38rem;
      margin-right: 0.2rem;
    }
  }
  .sta-star {
    width: 0.38rem;
    height: 0.38rem;
    margin-right: 0.2rem;
  }
  .qr-code {
    flex: 1;
    text-align: right;
  }
  .qr-code-btn {
    padding: 0.17rem 0.48rem;
    color: #fff;
    border-radius: 0.47rem;
    background-color: #14cc80;
    display: inline-block;
    font-size: 0.36rem;
    line-height: 0.5rem;
    border: none;
  }
}
</style>
